import Icon from "@mui/material/Icon";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import approvalReceiveImg from "assets/images/approval_receive.jpg";
import {useNavigate} from "react-router-dom";
import Grid from "@mui/material/Grid";

/**
 * 휴가 결재 수신함 버튼
 * @returns {JSX.Element}
 * @constructor
 */
function VacationApprovalReceiveBoxButton() {
    const navigate = useNavigate();

    return (
        <Grid
            className="vacation-approval-receive-box-button"
            onClick={() => navigate('/docs/receive',{state:'APT000'})}
            item
            xs={12}
            sx={{
                cursor: "pointer",
                "&:hover .material-icons-round": {
                    transform: `translate(6px, -0.5px)`,
                },
                "&:hover > div:nth-of-type(1)": {
                    backgroundImage: ({functions: {linearGradient, rgba}, palette: {gradients}}) =>
                        `${linearGradient(
                            rgba(gradients.info.main, 0.8),
                            rgba(gradients.info.state, 0.8)
                        )}, url(${approvalReceiveImg})`,
                },
            }}
        >
            <SoftBox
                p={2}
                borderRadius="lg"
                sx={{
                    backgroundImage: ({functions: {linearGradient, rgba}, palette: {gradients}}) =>
                        `${linearGradient(
                            rgba(gradients.dark.main, 0.8),
                            rgba(gradients.dark.state, 0.8)
                        )}, url(${approvalReceiveImg})`,
                    backgroundSize: "cover",
                }}
            >
                <SoftBox mb={3}>
                    <SoftTypography variant="h5" color="white" fontWeight="bold">
                        휴가 수신함
                    </SoftTypography>
                </SoftBox>
                <SoftTypography
                    variant="button"
                    color="white"
                    fontWeight="medium"
                    sx={{
                        mt: "auto",
                        mr: "auto",
                        display: "inline-flex",
                        alignItems: "center",

                        "& .material-icons-round": {
                            fontSize: "1.125rem",
                            transform: `translate(2px, -0.5px)`,
                            transition: "transform 0.2s cubic-bezier(0.34,1.61,0.7,1.3)",
                        },

                    }}
                >
                    Go
                    <Icon sx={{fontWeight: "bold"}}>arrow_forward</Icon>
                </SoftTypography>
            </SoftBox>
        </Grid>
    );
}

export default VacationApprovalReceiveBoxButton;
